import { IndexPage } from "@-/dev.improve.haniverse.routes.index";

// Render the lightweight marketing page in place so visiting the web root keeps `/` in the
// address bar. This route remains outside `(nav)`, so it cannot initialize app database providers.
export default function WebIndexRoute() {
  return <IndexPage />;
}
